// src/Dashboard/pages/teacher/PrepaPhysique/components/ExerciseFiltersCard.jsx

import React, { useEffect, useState } from "react";
import { FaFilter, FaPlus, FaSearch, FaTimes } from "react-icons/fa";

export default function ExerciseFiltersCard({
  filters,
  setFilters,
  programmes = [],
  loading,
  onAdd,
}) {
  const [localSearch, setLocalSearch] = useState(filters.search || "");

  useEffect(() => {
    setLocalSearch(filters.search || "");
  }, [filters.search]);

  useEffect(() => {
    const timer = setTimeout(() => {
      setFilters((previous) => ({
        ...previous,
        search: localSearch,
      }));
    }, 250);

    return () => clearTimeout(timer);
  }, [localSearch, setFilters]);

  const resetFilters = () => {
    setLocalSearch("");
    setFilters({
      search: "",
      programme: "All",
    });
  };

  return (
    <section className="overflow-hidden rounded-[28px] border border-slate-200 bg-white shadow-sm dark:border-slate-800 dark:bg-slate-900">
      <div className="h-1.5 bg-gradient-to-r from-[#013E8E] via-indigo-500 to-[#4CA82F]" />

      <div className="p-4 sm:p-5 lg:p-6">
        <div className="mb-4 flex flex-col gap-3 sm:flex-row sm:items-center sm:justify-between">
          <div>
            <p className="inline-flex items-center gap-2 text-sm font-bold text-slate-900 dark:text-white">
              <FaFilter />
              Filtres exercices
            </p>

            <p className="mt-1 text-xs text-slate-500 dark:text-slate-400">
              Recherchez par nom, description ou programme.
            </p>
          </div>

          <div className="flex flex-wrap gap-2">
            <button
              type="button"
              onClick={resetFilters}
              className="inline-flex items-center gap-2 rounded-2xl bg-slate-100 px-3 py-2 text-xs font-bold text-slate-700 transition hover:bg-slate-200 dark:bg-slate-800 dark:text-slate-200 dark:hover:bg-slate-700"
            >
              <FaTimes />
              Réinitialiser
            </button>

            <button
              type="button"
              onClick={onAdd}
              className="inline-flex items-center gap-2 rounded-2xl bg-[#013E8E] px-3 py-2 text-xs font-bold text-white transition hover:bg-indigo-800"
            >
              <FaPlus />
              Ajouter
            </button>
          </div>
        </div>

        <div className="grid grid-cols-1 gap-3 md:grid-cols-3">
          <div className="md:col-span-2">
            <label className="mb-1 block text-xs font-bold uppercase tracking-wide text-slate-500 dark:text-slate-400">
              Recherche
            </label>

            <div className="relative">
              <FaSearch className="pointer-events-none absolute left-3 top-1/2 -translate-y-1/2 text-slate-400" />

              <input
                type="text"
                value={localSearch}
                onChange={(event) => setLocalSearch(event.target.value)}
                disabled={loading}
                placeholder="Ex : gainage, pompes, cardio..."
                className="w-full rounded-2xl border border-slate-200 bg-white py-2 pl-9 pr-3 text-sm text-slate-900 outline-none transition focus:ring-2 focus:ring-indigo-400 disabled:opacity-60 dark:border-slate-700 dark:bg-slate-950 dark:text-white"
              />
            </div>
          </div>

          <div>
            <label className="mb-1 block text-xs font-bold uppercase tracking-wide text-slate-500 dark:text-slate-400">
              Programme
            </label>

            <select
              value={filters.programme}
              onChange={(event) =>
                setFilters((previous) => ({
                  ...previous,
                  programme: event.target.value,
                }))
              }
              disabled={loading}
              className="w-full rounded-2xl border border-slate-200 bg-white px-3 py-2 text-sm text-slate-900 outline-none transition focus:ring-2 focus:ring-indigo-400 disabled:opacity-60 dark:border-slate-700 dark:bg-slate-950 dark:text-white"
            >
              {(programmes || []).map((programme) => (
                <option key={programme} value={programme}>
                  {programme === "All" ? "Tous les programmes" : programme}
                </option>
              ))}
            </select>
          </div>
        </div>
      </div>
    </section>
  );
}